import { NotificationPreferences } from '../models/notification-preferences.model';

export interface UserSettingsInitialState {
    count: number | null;
    notificationPreferences: NotificationPreferences | null;
}

const initialUserSettingsState: UserSettingsInitialState = {
    count: null,
    notificationPreferences: null,
}

export default initialUserSettingsState
